import { CSSProperties, FC } from 'react';

import styles from './JabraStarRating.module.scss';

export interface JabraStarRatingProps {
  rating: number;
}

export const JabraStarRating: FC<JabraStarRatingProps> = ({ rating }) => {
  return (
    <div>
      <div
        style={{ '--rating': rating } as unknown as CSSProperties}
        className={styles.stars}
        aria-label="Rating of this product is 2.3 out of 5."
      ></div>
    </div>
  );
};
